export default function isTracker(deviceType) {
  const trackerTypes = [1, 4, 7, 14, 15, 16, 17];
  return trackerTypes.includes(deviceType);
}
